export default __webpack_public_path__ + "static/app-features-5-ca6e2867df865f883df6dfeb6e1a734c.webp";